export function filterNullable (obj) {
    const res = {}
    Object.entries(obj).forEach(([k, v]) => {
        if (!(typeof v === 'undefined' || v === '' || v === null)) {
            res[k] = v
        }
    })
    return res
}